import React from 'react';
import { purify } from '../../utils/helpers';
import { faq } from '@spotify-internal/structured-data-snippets';
import type TweakedFAQ from '.';

function StructuredData(payload: Parameters<typeof TweakedFAQ>[0]) {
  const mappedData =
    payload.data &&
    payload.data.map(i => {
      return { question: purify(i.header), answer: purify(i.content) };
    });
  if (!mappedData) return null;

  const structuredDataOutput = JSON.stringify(faq(mappedData));

  return (
    <script
      type="application/ld+json"
      // the payload has already been sanitised above
      dangerouslySetInnerHTML={{ __html: structuredDataOutput }}
    />
  );
}

export default StructuredData;
